export default {
  log: console.log,
  warn: console.warn,
  error: console.error
};
